import { makeStyles, createStyles } from '@material-ui/core/styles';
/* import sicrediStyles from 'assets/styles/default.scss'; */

export const useStyles = makeStyles(
  () =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
        fontFamily: 'Nunito',
      },
      contentText: {
        paddingBottom: '30px',
        paddingTop: '20px',

        '&.check-content': {
          paddingTop: '10px',
          paddingBottom: '20px',

          '& > p': {
            paddingBottom: '10px',
            marginLeft: '12px',
          },
        },
      },
      buttonContent: {
        '& > div:nth-child(2)': {
          marginRight: '-24px',
        },
      },
      buttonConfirm: {
        backgroundColor: '#e60000',
        '&:hover': {
          backgroundColor: '#d21818',
        },
      },
    }),
  {
    name: 'ConfirmDeletarPautaModal',
  }
);
